import { useQuery } from 'react-query';

import { PostRequest } from '../../../types/PostRequest';
import Api from '../../api/api';

export const getPostRequestOverride = async (id: string): Promise<PostRequest> => {
  const [response, bodyOrError] = await Api.get(`posts/requests/${id}`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useGetPostRequestOverride = (id: string) =>
  useQuery<PostRequest>(['getPostRequestOverride', id], () => getPostRequestOverride(id), {
    enabled: !!id,
  });
